import { useTranslation } from 'react-i18next';

interface System {
  titleKey: string;
  descKey: string;
  features: string[];
  img: string;
  badgeKey: string | null;
  badgeColor: string;
  isProduct?: boolean;
}

export default function WaterSystems() {
  const { t } = useTranslation();

  const systems: System[] = [
    {
      titleKey: 'ws2_title',
      descKey: 'ws2_desc',
      features: ['ws2_f1', 'ws2_f2', 'ws2_f3', 'ws2_f4', 'ws2_f5'],
      img: 'https://puronics.com/wp-content/uploads/2022/04/micromax-8500.png',
      badgeKey: 'ws2_badge',
      badgeColor: 'bg-emerald-500',
      isProduct: true,
    },
    {
      titleKey: 'ws3_title',
      descKey: 'ws3_desc',
      features: ['ws3_f1', 'ws3_f2', 'ws3_f3', 'ws3_f4', 'ws3_f5'],
      img: 'https://puronics.com/wp-content/uploads/2019/12/terminator-igen-12.19.png',
      badgeKey: null,
      badgeColor: '',
      isProduct: true,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('ws_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-4">
            {t('ws_title1')}<br />{t('ws_title2')}
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">{t('ws_desc')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {systems.map((system) => (
            <div key={system.titleKey} className="rounded-2xl overflow-hidden border border-slate-100 bg-white flex flex-col hover:border-sky-100 transition-all duration-300">
              {/* Image */}
              <div className={`relative h-52 overflow-hidden ${system.isProduct ? 'bg-slate-50' : ''}`}>
                <img
                  src={system.img}
                  alt={t(system.titleKey)}
                  className={`w-full h-full ${system.isProduct ? 'object-contain p-4' : 'object-cover object-top'}`}
                />
                {!system.isProduct && (
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
                )}
                {system.badgeKey && (
                  <div className={`absolute top-4 left-4 ${system.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide`}>
                    {t(system.badgeKey)}
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-7 flex-1 flex flex-col">
                <h3 className="text-xl font-black text-slate-800 mb-3">{t(system.titleKey)}</h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-5">{t(system.descKey)}</p>

                <ul className="space-y-2.5 mb-7 flex-1">
                  {system.features.map((fKey) => (
                    <li key={fKey} className="flex items-center gap-2.5 text-sm text-slate-700">
                      <div className="w-4 h-4 flex items-center justify-center shrink-0">
                        <i className="ri-check-double-line text-sky-500 text-base"></i>
                      </div>
                      {t(fKey)}
                    </li>
                  ))}
                </ul>

                <a
                  href="#water-form"
                  className="w-full bg-sky-50 hover:bg-sky-100 border border-sky-200 text-sky-700 font-bold py-3 rounded-lg text-sm text-center cursor-pointer transition-colors block whitespace-nowrap"
                >
                  {t('ws_cta_btn')}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
